import { Injectable } from "@angular/core";
import swal, { SweetAlertIcon, SweetAlertPosition } from 'sweetalert2';
import { LocalizationService } from "../localization/localization.service";
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from "@angular/material/snack-bar";
declare const $: any;
export type NotificationType = 'basic' | 'title-and-text' | 'success-message' | 'error-message' | 'custom-html' | 'warning-message-and-confirmation';
export type ToastType = 'success' | 'error' | 'warning' | 'info' | 'question';
export type SnackbarColor = 'purple' | 'red' | 'blue';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    constructor(private _localizationSrevice: LocalizationService,
        private _snackBar: MatSnackBar) {
    }
    showSnackBar(message: string, snackbarColor: SnackbarColor = 'purple', horizontalPosition: MatSnackBarHorizontalPosition = 'center', verticalPosition: MatSnackBarVerticalPosition = 'top') {
        let snackBarRef = this._snackBar.open(message, 'Close', {
          panelClass: ['otis-snackbar', `${snackbarColor}-snackbar`],
          horizontalPosition: horizontalPosition,
          verticalPosition: verticalPosition,
        });
        return snackBarRef;
      }
      hideSnackBar(){
        this._snackBar.dismiss();
      }
    toastMessage(message: string, type: ToastType, time: number = 3000) {
        swal.mixin({
            toast: true,
            position: 'top-right',
            iconColor: 'white',
            customClass: {
                popup: 'colored-toast'
            },
            showConfirmButton: false,
            timer: time,
            timerProgressBar: true
        }).fire({
            icon: type,
            title: message
        });
    }
    toastRight(title: string, type: ToastType, iconClr: string, time: number = 25000, customClass = 'toast-right') {
    swal.fire({
      toast: true,
      position: "top-end",
      icon: type,
      title: title,
      iconColor: iconClr,
      showConfirmButton: false,
      showCloseButton: true,
      timer: time,
      customClass: {
        popup: customClass
      },
      timerProgressBar: true,
    });
  }
    basicMessage(message: string, position?: SweetAlertPosition) {
        this.showSwal('basic', message, '', null, position);
    }
    basicMessageWithTitle(message: string, title: string, position?: SweetAlertPosition) {
        this.showSwal('title-and-text', message, title, null, position);
    }
    successMessage(message: string, title: string, position?: SweetAlertPosition) {
        this.showSwal('success-message', message, title, null, position);
    }
    errorMessage(message: string, title: string, position?: SweetAlertPosition) {
        this.showSwal('error-message', message, title, null, position);
    }
    htmlMessage(message: string, title: string, position?: SweetAlertPosition) {
        this.showSwal('custom-html', message, title, null, position);
    }
    deleteConfirmation(message: string, title: string, okcallback: any, position?: SweetAlertPosition) {
        this.showSwal('warning-message-and-confirmation', message, title, okcallback, position);
    }
    customNotification(message: string, title: string, icon: SweetAlertIcon,
        iconColor?: string, footer?: string, imageUrl?: string, imageHeight?: string, imageWidth?: string, imageAlt?: string,
        html?: string, showCloseButton?: boolean,
        showCancelButton?: boolean, focusConfirm?: boolean, confirmButtonText: string = 'Ok', confirmButtonAriaLabel?: string,
        cancelButtonText: string = 'Cancel', cancelButtonAriaLabel?: string, confirmButtonColor?: string, cancelButtonColor?: string) {
        swal.fire({
            title, text: message, icon, iconColor, footer, imageUrl, imageHeight, imageWidth,
            imageAlt, html, showCloseButton, showCancelButton, focusConfirm, confirmButtonText,
            confirmButtonAriaLabel, cancelButtonText, cancelButtonAriaLabel, confirmButtonColor, cancelButtonColor
        });
    }
    showSwal(type: string, message?: string, title?: string, callback?: any, position?: SweetAlertPosition) {
        position = position ? position : 'center';
        if (type == 'basic') {
            swal.fire({
                position: position,
                title: message,
                buttonsStyling: false,
                customClass: {
                    confirmButton: "btn btn-success"
                }
            });

        } else if (type == 'title-and-text') {
            swal.fire({
                position: position,
                title: title,
                text: message,
                buttonsStyling: false,
                customClass: {
                    confirmButton: "btn btn-info"
                }
            });

        } else if (type == 'success-message') {
            swal.fire({
                position: position,
                title: title,
                text: message,
                buttonsStyling: false,
                customClass: {
                    confirmButton: "btn btn-success",
                },
                icon: "success"
            });

        } else if (type == 'error-message') {
            swal.fire({
                position: position,
                title: title,
                text: message,
                buttonsStyling: false,
                customClass: {
                    confirmButton: "btn btn-success",
                },
                icon: "error"
            });

        } else if (type == 'warning-message-and-confirmation') {
            swal.fire({
                position: position,
                title: title,
                html: message,
                icon: 'question',
                showCancelButton: true,
                customClass: {
                    confirmButton: 'btn btn-success',
                    cancelButton: 'btn btn-danger',
                },
                confirmButtonText: this._localizationSrevice.instant('menu.okbtn'),
                cancelButtonText: this._localizationSrevice.instant('menu.cancelbtn'),
                buttonsStyling: true
            }).then((result) => {
                if (result.value) {
                    if (callback)
                        callback();
                }
            })
        } else if (type == 'warning-message-and-cancel') {
            swal.fire({
                position: position,
                title: 'Are you sure?',
                text: 'You will not be able to recover this action!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: this._localizationSrevice.instant('menu.okbtn'),
                cancelButtonText: this._localizationSrevice.instant('menu.cancelbtn'),
                customClass: {
                    confirmButton: "btn btn-success",
                    cancelButton: "btn btn-danger",
                },
                buttonsStyling: false
            }).then((result) => {
                if (result.value) {
                    swal.fire({
                        position: position,
                        title: 'Deleted!',
                        text: 'Your imaginary file has been deleted.',
                        icon: 'success',
                        customClass: {
                            confirmButton: "btn btn-success",
                        },
                        buttonsStyling: false
                    });
                } else {
                    swal.fire({
                        position: position,
                        title: 'Cancelled',
                        text: 'Your imaginary file is safe :)',
                        icon: 'error',
                        customClass: {
                            confirmButton: "btn btn-info",
                        },
                        buttonsStyling: false
                    });
                }
            })

        } else if (type == 'custom-html') {
            swal.fire({
                position: position,
                title: 'HTML example',
                buttonsStyling: false,
                customClass: {
                    confirmButton: "btn btn-success",
                },
                html: 'You can use <b>bold text</b>, ' +
                    '<a href="http://github.com">links</a> ' +
                    'and other HTML tags'
            });

        } else if (type == 'auto-close') {
            swal.fire({
                position: position,
                title: "Auto close alert!",
                text: "I will close in 2 seconds.",
                timer: 2000,
                showConfirmButton: false
            });
        } else if (type == 'input-field') {
            swal.fire({
                position: position,
                title: 'Input something',
                html: '<div class="form-group">' +
                    '<input id="input-field" type="text" class="form-control" />' +
                    '</div>',
                showCancelButton: true,
                customClass: {
                    confirmButton: 'btn btn-success',
                    cancelButton: 'btn btn-danger',
                },
                buttonsStyling: false
            }).then(function (result) {
                swal.fire({
                    position: position,
                    icon: 'success',
                    html: 'You entered: <strong>' +
                        $('#input-field').val() +
                        '</strong>',
                    customClass: {
                        confirmButton: 'btn btn-success',
                    },
                    buttonsStyling: false

                })
            });
        }
    }
}
